export default "__VITE_ASSET__DufuoE$Z__"